import axios from "@/libs/api.request";
export function getQuoTreeNum(params) {
    return axios.request({
        url: "WebQuo/getQuoTreeNum",
        method: "get",
        params:params,
    })
}
//获取订单上表信息
export function getQuoMain(params) {
    return axios.request({
        url: "WebQuo/getQuoMainList",
        method: "get",
        params:params,
    })
}
//获取订单下表信息
export function getQuoDetail(params) {
    return axios.request({
        url: "WebQuo/getQuoDetailList",
        method: "get",
        params:params,
    })
}